import { preview } from '@/components/form/preview'
import { useTexts } from '../hooks/useTexts'
import { useChangePasswordModal } from '../modals/ChangePasswordModal'
import { Edit, Password } from '@mui/icons-material'

interface Props {
  onEdit: () => void
}

export function Header(props: Props) {
  const { onEdit } = props

  const texts = useTexts()
  const { Modal: ChangePasswordModal, show: showChangePasswordModal } = useChangePasswordModal()

  return (
    <preview.Header
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      testId="account-settings-view-header"
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={onEdit}
          label={texts.edit}
          disableWhenReadOnly
          tooltip={texts.edit}
          testId="account-settings__edit"
          data-trackid="account-settings__edit"
        />
        <preview.ActionBarItem
          icon={<Password />}
          onClick={showChangePasswordModal}
          label={texts.changePassword}
          tooltip={texts.changePassword}
          testId="account-settings__change-password"
          data-trackid="account-settings__change-password"
          disableWhenReadOnly={false}
        />
      </preview.ActionBar>

      <ChangePasswordModal />
    </preview.Header>
  )
}
